import styled from '@emotion/styled';
import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Iconify from '@src/components/iconify';
import { useHomePageEditorContext } from '../provider';


function SuccessDialog() {
  const { success, setSuccess } = useHomePageEditorContext();

  return (
    <BootstrapDialog
      open={success}
      onClose={() => setSuccess(false)} 
      >
      <DialogContent>
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <ButtonClose onClick={() => setSuccess(false)}>
            <Iconify  icon={'mdi:close'} width={25} />
          </ButtonClose>
          <Iconify  icon={'mdi:check-circle'} color="#33BB48" width={50} />

          <Typography 
            fontSize={28}
            fontWeight={"700"}
            color="#33BB48">SUCCESS</Typography>
          <Typography 
            mt={1}
            fontSize={16}
            fontWeight={"500"}
            color="#202224">Rewards Page has been published.</Typography>
          <ButtonOkay onClick={() => setSuccess(false)}>OKAY</ButtonOkay>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: 613,
    height: 328,
    borderRadius: 20,
    margin: 0, // Removes margin
    padding: 0, // Removes padding
  },
}));

export const ButtonClose = styled(Button)(({ theme }) => ({
  width: 30, 
  height: 30,
  color: "#7D7D7D", 
  backgroundColor: "white", 
  position: "absolute",
  top: 20,
  right: 10,
}));

export const ButtonOkay = styled(Button)(({ theme }) => ({
  width: 237, 
  height: 50,
  marginTop: 20,
  color: "white", 
  fontWeight: 700,
  backgroundColor: "#6A00AC", 
}));

export default SuccessDialog;